module.exports = __webpack_public_path__ + "media/images/lb/400-2658c18c6a84531c30c72e56f83d83c0.svg";